import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSettings } from '@atlas/core';
import cx from 'classnames';
import { isRtlLanguage } from '../helpers/isRtlLanguage';

const useBodyClassName = () => {
  const { lang } = useSettings();
  const { pathname } = useLocation();

  useEffect(() => {
    const isRtl = isRtlLanguage({ lang });

    const activePageClassName = pathname
      .split('/')
      .filter(i => i)
      .map(i => `${i}-body-class`)
      .join(' ');

    document.body.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
    document.body.className = cx(`${activePageClassName}`);
  }, [pathname, lang]);
};

export default useBodyClassName;
